'use client';

import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import * as Sentry from "@sentry/nextjs";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Fatal application error:', error);
    console.log('Error digest:', error.digest);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
          <div className="bg-white border border-gray-200 rounded-xl p-8 max-w-md w-full text-center shadow-lg">
            <div className="flex justify-center mb-6">
              <div className="bg-red-100 p-3 rounded-full">
                <AlertTriangle className="h-10 w-10 text-red-500" />
              </div>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              Application Error
            </h2>
            
            <p className="text-gray-600 mb-6">
              A critical error has occurred. We've been notified and are investigating the issue.
            </p>
            
            <Button 
              variant="default"
              className="w-full bg-primary hover:bg-primary/90"
              onClick={() => window.location.href = '/dashboard'}
            >
              Restart Application
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full mt-3 border-gray-300 hover:bg-gray-100" 
              onClick={() => reset()}
            >
              Try again
            </Button>
            
            {error.digest && (
              <p className="mt-6 text-xs text-gray-400">
                Error ID: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  );
} 